import { useRef } from "react";
import Select, { components } from "react-select";
import cs from "classnames";
import { Text } from "../../Type";
import {
  CheckMarkRounded,
  ChevronBottom,
  X,
} from "../../Icons/general-interface-1";
import {
  control,
  clearIndicator,
  dropdownIndicator,
  indicatorSeparator,
  menu,
  menuList,
  placeholder,
  valueContainer,
} from "../commonStyles";
import commonStyles from "../index.module.scss";
import styles from "./index.module.scss";

type PropsType = {
  options: { value: string; label: string }[];
  onChange: (locations: { value: string; label: string }[]) => void;
  values?: { value: string; label: string }[];
};

const ClearIndicator = ({ ...props }) => (
  <components.ClearIndicator {...props}>
    <X />
  </components.ClearIndicator>
);

const DropdownIndicator = ({ ...props }) => (
  <components.DropdownIndicator {...props}>
    <ChevronBottom />
  </components.DropdownIndicator>
);

const Option = (props) => {
  return (
    <components.Option {...props}>
      <div className={cs(styles.checkbox, props.isSelected && styles.checked)}>
        {props.isSelected && <CheckMarkRounded />}
      </div>
      <div className={styles.optionLabel}>{props.data.label}</div>
    </components.Option>
  );
};

const MultiValueRemove = (props) => (
  <components.MultiValueRemove {...props}>
    <X width="12px" height="12px" />
  </components.MultiValueRemove>
);

const MultiValueLabel = (props) => (
  <components.MultiValueLabel {...props}>
    <Text size="small">{props.children}</Text>
  </components.MultiValueLabel>
);

const customStyles = {
  control,
  clearIndicator,
  dropdownIndicator,
  indicatorSeparator,
  menu,
  menuList,
  placeholder,
  valueContainer,
  option: (provided, state) => ({
    ...provided,
    width: "100%",
    padding: "12px 16px",
    background: state.isFocused ? commonStyles.blue_100 : "transparent",
    display: "flex",
    alignItems: "flex-start",
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: commonStyles.grey_100,
    borderRadius: "4px",
    border: `1px solid ${commonStyles.grey_300}`
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    padding: "2px",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    transition: "color 150ms ease-in-out",
    ":hover": {
      backgroundColor: commonStyles.grey_100,
      color: commonStyles.red_300,
    },
  }),
};

const LocationFilterDropdown = ({ options, onChange, values }: PropsType) => {
  const selectRef = useRef<Select | null>(null);
  const handleOnChange = (selection) => {
    onChange(selection);
  };

  return (
    <Select
      ref={selectRef}
      styles={customStyles}
      classNamePrefix="statusFilterDropdown"
      placeholder="Filter by location"
      onChange={handleOnChange}
      options={options}
      maxMenuHeight="197px"
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      isSearchable={false}
      isMulti
      isClearable
      components={{
        ClearIndicator,
        DropdownIndicator,
        Option,
        MultiValueRemove,
        MultiValueLabel,
      }}
      //selectRef={!selectRef.current ? null : selectRef.current}
      value={values}
      />
  );
};

export default LocationFilterDropdown;
